import { createSlotRecipe } from './runtime';

const fieldConfig = {"name":"field","slots":["root","label","requiredIndicator","helperText","errorMessage"],"defaultVariants":{"labelPosition":"top","size":"md"},"variantMap":{"size":["lg","md","sm"],"labelPosition":["top","side"]}}

export const field = /* @__PURE__ */ createSlotRecipe(fieldConfig)